// 画像プレビューモーダル
const ModalImagePreview = {
  namespaced: true,

  state: {
    modal: false,
    images: [],
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getImages: state => {
      return state.images
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setImages(state, images) {
      state.images = images
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setImages', item.images)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setImages', [])
    },
  },
}

export default ModalImagePreview
